import * as React from 'react';
import {Textbox} from 'ui/textbox/textbox';
import {SingleValueComponent} from 'ui/common';
import { ValidationLevel } from 'ui/common';
import{isValidUrl} from 'app/infrastructure/validation/url';

interface SafeAnchorProps extends SingleValueComponent<string>{
  textInvalidAnchor?: string;
  maxLength?: number;
}

interface SafeAnchorState {
  anchorValue: string;
  invalidAnchor: boolean;
}

export class SafeAnchor extends React.Component<SafeAnchorProps, SafeAnchorState> {

  constructor(props: SafeAnchorProps) {
    super(props);
    this.state = {anchorValue: props.value || '', invalidAnchor: false};
  }

  private onChange = (value: string)=> {

    if(!isValidUrl(value.trim())) {
      this.setState({anchorValue: value.trim(), invalidAnchor: true});
      return;
    }
    this.setState({anchorValue: value.trim(), invalidAnchor: false});
    this.props.onChange(value.trim());
  }

  private onBlur = (value: string)=> {
    if(!isValidUrl(value.trim())) {
      this.setState({invalidAnchor: true});
      return false;
    }
    this.setState({anchorValue: value.trim(), invalidAnchor: false});
    return true;
  }

  public componentDidUpdate(prevProps:SafeAnchorProps) {
    if(this.props.value !== prevProps.value) {
      this.setState({anchorValue: this.props.value});
    }
  }

  public render() {
    const {maxLength, textInvalidAnchor} = this.props;
    const {invalidAnchor, anchorValue} = this.state;

    const errorParams = {level: ValidationLevel.error,
                          messages: [{level: ValidationLevel.error, message: `${textInvalidAnchor}`}]
                        };

    return (
      <Textbox
        {...this.props}
        value={anchorValue}
        onChange={this.onChange}
        maxLength={maxLength}
        onBlur={this.onBlur}
        validation={invalidAnchor && errorParams}
      />
    );
  }
}
